import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { ScrollPage } from './pages/ScrollPage';
const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false
  },
  styles: {
    global: {
      body: {
        bg: '#FFFFFF',
        color: '#1D1D1F',
        fontFamily: "'DM Sans', system-ui, sans-serif"
      }
    }
  },
  fonts: {
    heading: "'Playfair Display', Georgia, serif",
    body: "'DM Sans', system-ui, sans-serif",
    mono: "'Courier New', Courier, monospace"
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: '980px',
        fontFamily: "'DM Sans', sans-serif"
      }
    }
  }
});
export function App() {
  return <ChakraProvider theme={theme} data-id="element-0">
      <ScrollPage data-id="element-1" />
    </ChakraProvider>;
}